import { useSubscriptions } from "@/Common/context/subscriptions/Subscriptions";
import { normalizePositions } from "@/Common/helpers/Positions";
import { useEffect, useState } from "react";

import { updatePdfAvailability } from "@/PayPlans/api/assignments/subscriptions";
import { PayPlanAvailability } from "@/PayPlans/types/hooks/useTermsAndCondition";
import { GraphqlQueryResponse } from "@/Common/api/types/GraphqlQueryResponse";
import { useSelector } from "react-redux";
import { RootState } from "@/redux/store";

export const useTermsAndConditionEdition = (positionArg: string) => {
	const locationIdArg = useSelector((state: RootState) => state.location.location)?.locationId ?? "";
	const [payPlanAvailability, setPayPlanAvailability] = useState<PayPlanAvailability | undefined>();
	const { addSubscription, deleteSubscription, getSubscription } = useSubscriptions();

	const subscriptionKey = ["payPlanPdfAvailability", locationIdArg];

	if (positionArg) {
		subscriptionKey.push(positionArg);
	}

	const payPlanPdfAvailabilitySubscription = getSubscription(subscriptionKey);

	payPlanPdfAvailabilitySubscription?.setInvalidate(subscriptionKey);
	payPlanPdfAvailabilitySubscription?.subscriptions?.onUpdatePdfAvailability?.setCallback(
		(args: GraphqlQueryResponse<"onUpdatePdfAvailability", PayPlanAvailability | undefined>["data"]) => {
			const pdfAvailabilityData: PayPlanAvailability | undefined = args.data?.onUpdatePdfAvailability;

			setPayPlanAvailability(pdfAvailabilityData);
		}
	);

	//pay plan pdf availability process
	useEffect(() => {
		if (locationIdArg && positionArg) {
			const position = normalizePositions(positionArg);
			addSubscription(
				subscriptionKey,
				[
					{
						context: "onUpdatePdfAvailability",
						query: updatePdfAvailability,
						variables: {
							position,
							locationId: locationIdArg,
						},
					},
				],
				true
			);
		} else if (locationIdArg) {
			addSubscription(
				subscriptionKey,
				[
					{
						context: "onUpdatePdfAvailability",
						query: updatePdfAvailability,
						variables: {
							locationId: locationIdArg,
						},
					},
				],
				true
			);
		}

		return () => {
			deleteSubscription(subscriptionKey);
		};
	}, [locationIdArg, positionArg]);

	return { payPlanAvailability };
};
